<script>
	import { t } from '$lib/translations'
	import { Anchor, Separator } from './index.js'
	export let header = null
</script>

<div class="background">
	<Anchor id="form" />
	<div class="header-wrapper">
		<Separator />
		<h1 class="text-center">{t(header?.heading)}</h1>
		{#if header?.subheading}
			<p class="text-gray">{@html t(header.subheading)}</p>
		{/if}
		<slot />
	</div>
</div>

<style lang="scss">
	.background {
		width: 100vw;
		position: relative;
		background: #f4f4f4;
		left: 50%;
		transform: translateX(-50%);

		@media only screen and (max-width: 760px) {
			padding-bottom: 0;
		}

		.header-wrapper {
			margin-bottom: 25px;
			margin-top: 40px;
			padding: 40px 15px 25px 15px;
			width: 100%;
			max-width: 1360px;
			margin: 0 auto;
			box-sizing: border-box;
			width: 100%;

			@media only screen and (max-width: 760px) {
				flex-direction: column;
				padding-bottom: 15px;
			}

			p {
				text-align: center;
				width: 75%;
				display: block;
				margin: 0 auto;

				@media only screen and (max-width: 760px) {
					width: 100%;
				}
			}
		}
	}
</style>
